export default __webpack_public_path__ + "static/Stars-over-Iceland-credit-Claudia-Regina-ba9ce8f249af41d6a6722c5cd0842c93.jpg";